module.exports = __webpack_public_path__ + "img/图.96527150.webp";